var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonAnticipation = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 49", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { clipPath: "url(#icon-anticipation_svg__clip0_403_3012)" },
            React.createElement("path", { d: "M29.632 36.423a4.992 4.992 0 013.512-1.456h3.914A4.968 4.968 0 0142 39.91v2.734a1.982 1.982 0 01-1.982 1.982h-9.834a1.982 1.982 0 01-1.982-1.982V39.91a4.917 4.917 0 011.43-3.487zM29.883 26.864a5.218 5.218 0 1110.436 0 5.218 5.218 0 01-10.436 0z", fill: fills.light }),
            React.createElement("path", { d: "M7.455 36.423a4.943 4.943 0 013.512-1.456h3.889a4.967 4.967 0 014.967 4.943v2.734a1.984 1.984 0 01-2.007 1.982H7.982A1.982 1.982 0 016 42.644V39.91a4.942 4.942 0 011.455-3.487zM7.706 26.864a5.218 5.218 0 1110.436 0 5.218 5.218 0 01-10.436 0zM35.352 18.46a1.305 1.305 0 01-1.305-1.304V9.755a2.734 2.734 0 00-2.734-2.735H17.139a2.734 2.734 0 00-2.76 2.735v6.397a1.305 1.305 0 01-2.609 0V9.755a5.369 5.369 0 015.369-5.369h14.174a5.344 5.344 0 015.343 5.369v7.4a1.304 1.304 0 01-1.304 1.305z", fill: fills.dark }),
            React.createElement("path", { d: "M35.076 19.012a1.279 1.279 0 01-.928-.376l-4.616-4.616a1.33 1.33 0 010-1.857 1.33 1.33 0 011.881 0l3.663 3.688 3.688-3.688a1.313 1.313 0 011.856 1.857l-4.616 4.616a1.28 1.28 0 01-.928.376z", fill: fills.dark })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "icon-anticipation_svg__clip0_403_3012" },
                React.createElement("path", { fill: "#fff", transform: "translate(6 4.386)", d: "M0 0h36v40.24H0z" })))));
}, {
    name: identiconComponentName,
})({});
